export const DEFAULT_AUTH_REDIRECT = '/tasks';

export function validateAuthSearch(search: Record<string, unknown>): {
  redirect?: string;
} {
  return typeof search.redirect === 'string' &&
    isSafeAuthRedirect(search.redirect)
    ? { redirect: search.redirect }
    : {};
}

export function isSafeAuthRedirect(redirectTarget: string) {
  if (!redirectTarget.startsWith('/') || redirectTarget.startsWith('//')) {
    return false;
  }

  let decodedRedirect: string;
  try {
    decodedRedirect = decodeURIComponent(redirectTarget);
  } catch {
    return false;
  }

  if (decodedRedirect.startsWith('//') || decodedRedirect.includes('\\')) {
    return false;
  }

  // Parsing base only: resolve relative paths and detect a changed origin.
  // This does not make a network request or depend on the deployment hostname.
  const parsedRedirect = new URL(decodedRedirect, 'https://example.com');

  if (parsedRedirect.origin !== 'https://example.com') {
    return false;
  }

  const normalizedPathname =
    parsedRedirect.pathname.replace(/\/+$/, '').toLowerCase() || '/';

  return !['/sign-in', '/two-factor', '/sign-out'].includes(normalizedPathname);
}
